import aHttp from '@/models/axiosConfig/aHttp';
import constants from '@/constants';
const {
  API_LIST: { EMTCSLP_EXTERNAL_APIGATEWAY_PROD }
} = constants;

export const persistShippingAddress = data =>
  aHttp.post(
    `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/address/persistShippingAddress`,
    data
  );
export const countryProvincesData = data =>
  aHttp.get(
    `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/address/countryProvincesData`,
    data
  );
